import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(public snackBar: MatSnackBar) {
  }

  showSuccess(message: string, duration = 5000): void {
    this.snackBar.open(message, 'x',{
      duration: duration,
      panelClass: ['snack-success']
    });
  }

  showError(message: string, duration = 5000): void {
    // The second parameter is the text in the button.
    // In the third, we send in the css class for the snack bar.
    this.snackBar.open(message, 'x', {
      duration: duration,
      panelClass: ['snack-error']});
  }

  showInfo(message: string, duration = 5000): void {
    // The second parameter is the text in the button.
    // In the third, we send in the css class for the snack bar.
    this.snackBar.open(message, 'x', {
      duration: duration,
      panelClass: ['snack-info']});
  }


}
